export default __webpack_public_path__ + "static/about1-aa1ee26ab4f3d8cea1c8a83e1d648064.jpg";